import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { Box, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const CloseButton = ({ isSignIn, path, ...props }) => {
    const router = useNavigate();
    return (
        <Box
            {...(isSignIn && {
                onClick: () => {
                    localStorage.removeItem('fromWhere');
                    router(path);
                },
            })}
            as={Flex}
            justifyContent='center'
            alignItems='center'
            h='30px'
            w='30px '
            borderRadius='5px'
            _hover={{
                background: '#EDF2F7',
            }}
            pos='absolute'
            top='5px'
            right='5px'
            cursor='pointer'
            {...props}
        >
            <FontAwesomeIcon icon={faClose} />
        </Box>
    );
};

export default CloseButton;
